// src/pages/Users/Produits/ProductCard.jsx
import React from "react";
import { FaExternalLinkAlt } from "react-icons/fa";

function onImgError(e, fallback) {
  if (e?.currentTarget) e.currentTarget.src = fallback;
}

// --- Helpers liens démo ---
const ensureHttp = (u = "") => (/^https?:\/\//i.test(u) ? u : `https://${u}`);
const parseDemoLinks = (input) =>
  (Array.isArray(input) ? input : String(input || "").split(";"))
    .map((s) => s.trim())
    .filter(Boolean);

const hostLabel = (u, idx) => {
  try {
    const { hostname } = new URL(ensureHttp(u));
    return hostname.replace(/^www\./, "");
  } catch {
    return `Démo ${idx + 1}`;
  }
};

export default function ProductCard({ app, fallback = "/img/no-image.jpg" }) {
  const { nom_app, description_app, image_url_app, lien_url_app } = app || {};
  const imgSrc = image_url_app?.trim() ? image_url_app : fallback;

  const demoLinks = parseDemoLinks(lien_url_app);
  const hasMultiple = demoLinks.length > 1;

  return (
    <div className="group bg-base-100 shadow ring-1 ring-slate-200/70 dark:ring-slate-800/70 rounded-2xl overflow-hidden hover:shadow-lg transition h-full flex flex-col">
      <div
        className="w-full bg-slate-50 dark:bg-slate-900 flex items-center justify-center"
        style={{ aspectRatio: "16 / 9" }}
      >
        <img
          src={imgSrc}
          alt={nom_app}
          className="w-full h-full object-contain"
          loading="lazy"
          onError={(e) => onImgError(e, fallback)}
        />
      </div>

      <div className="p-4 flex flex-col flex-1">
        <h3 className="text-lg font-semibold text-slate-900 dark:text-white">{nom_app}</h3>
        <p className="mt-2 text-sm text-slate-700 dark:text-slate-300 flex-1">
          {description_app || "Description non renseignée."}
        </p>

        <div className="mt-4">
          {demoLinks.length === 0 && (
            <span className="text-xs text-slate-500 dark:text-slate-400 italic">
              Lien non disponible
            </span>
          )}

          {demoLinks.length === 1 && (
            <a
              href={ensureHttp(demoLinks[0])}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-sm font-semibold text-sky-700 hover:text-sky-900 dark:text-sky-400 dark:hover:text-sky-300"
              title="Ouvrir la démo"
            >
              Découvrir / Exemple <FaExternalLinkAlt />
            </a>
          )}

          {hasMultiple && (
            <div className="flex flex-wrap gap-2">
              {demoLinks.slice(0, 3).map((u, i) => (
                <a
                  key={`${u}-${i}`}
                  href={ensureHttp(u)}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={u}
                  className="inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-sm font-semibold
                             ring-1 ring-slate-300 text-sky-700 hover:text-sky-900 hover:ring-sky-300
                             dark:text-sky-300 dark:hover:text-sky-200 dark:ring-slate-700
                             transition transform hover:scale-[1.03] focus:outline-none focus:ring-2 focus:ring-violet-400"
                >
                  {hostLabel(u, i)} <FaExternalLinkAlt />
                </a>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
